import React from 'react';
import classNames from 'classnames';

import MicIcon from '../../../../../components/ui/icons/MicIcon';
import styles from './NoEpisodes.scss';

import {
  withI18n,
  IWithI18nProps,
} from '../../../../../components/context/i18n';

interface IStyle {
  [key: string]: string;
}

interface INoEpisodesProps extends IWithI18nProps {
  dynamicStyle: IStyle;
}

const NoEpisodes: React.FC<INoEpisodesProps> = ({ dynamicStyle, t }) => (
  <div className={styles.noEpisodesWrapper}>
    <div className={classNames(styles.noEpisodes, dynamicStyle.noEpisodes)}>
      <MicIcon />
      <div className={styles.text}>{t('pages.main.no-episodes')}</div>
    </div>
  </div>
);

export default withI18n(NoEpisodes);
